import jQuery from 'jquery';
import autocomplete from 'jquery-ui/ui/widgets/autocomplete';
import placeholderEnhanced from './../../vendor/jquery.placeholder-enhanced.1.6.9';
import ga from './../../vendor/google-analytics';

export default (function($) {
	$(function() {
    var options = $.extend({
      'fieldName': 'input[name=s]',
      'maxRows': 10,
      'minLength': 3
    });

    $(options.fieldName).each(function() {
      var $this = $(this);

      $this.autocomplete({
        source: function (request, response) {
          $.ajax({
            url: window.themosis.ajaxurl,
            dataType: "json",
            data: {
              action: 'autocomplete_callback',
              query: $this.val()
            },
            success: function (data) {
              response($.map(data, function (hit) {
                return {
                  label: hit.autocomplete_title,
                  value: hit.permalink
                }
              }));
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.log(jqXHR, textStatus, errorThrown);
            }
          });
        },
        minLength: options.minLength,
        search: function (event, ui) {
          $(event.currentTarget).addClass('sa_searching');
        },
        create: function () {
        },
        select: function (event, ui) {

          // Safety check before indexing in
          if (ui.item.label && ui.item.label.length > 0) {

            // Try to track the search term entered and the autocomplete
            // choice. May pass or fail based on how browsers handle the
            // window.location call
            ga(
              'send',
              'event',
              'Autocomplete Search',
              'Select',
              $this.val() + ' | ' + ui.item.label[0],
              {transport: 'beacon'}
            );
          }

          // Update the autocomplete and send the user to their destination
          $this.val(ui.item.label);
          window.location = ui.item.value;

          return false;
        },
        focus: function (event, ui) {
          if (ui && ui.item && ui.item.label) {
            $this.val(ui.item.label);
          }

          return false;
        },
        open: function (event, ui) {
          $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
          $(event.target).removeClass('sa_searching');
        },
        close: function () {
        }
      });
    });
	});

  // Execute the extra placeholder polyfill across the searchbox elements
  $('.search-field').placeholderEnhanced();
})(jQuery);